export function Footer() {
  const linkStyle = {
    fontSize: 'var(--text-label-sm)',
    color: 'var(--color-text-secondary)',
    textDecoration: 'none',
  } as const

  const handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.color = 'var(--color-action-primary)'
  }
  const handleMouseLeave = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.color = 'var(--color-text-secondary)'
  }

  return (
    <footer
      style={{
        borderTop: '1px solid var(--color-outline-hairline)',
        padding: '24px var(--page-padding-horizontal)',
        textAlign: 'center',
        fontFamily: 'var(--font-body)',
      }}
    >
      <nav aria-label="Legal links">
        <a
          href="https://zota.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Privacy Policy
        </a>
        <span
          aria-hidden="true"
          style={{
            fontSize: 'var(--text-label-sm)',
            color: 'var(--color-text-tertiary)',
            margin: '0 var(--spacing-2)',
          }}
        >
          &middot;
        </span>
        <a
          href="https://zota.com/terms-of-use/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Terms of use
        </a>
        <span
          aria-hidden="true"
          style={{
            fontSize: 'var(--text-label-sm)',
            color: 'var(--color-text-tertiary)',
            margin: '0 var(--spacing-2)',
          }}
        >
          &middot;
        </span>
        <a
          href="https://zota.com/contact/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          Contact
        </a>
      </nav>
      <p
        style={{
          margin: '12px auto 0',
          maxWidth: '560px',
          fontSize: 'var(--text-label-sm)',
          color: 'var(--color-text-tertiary)',
          lineHeight: 'var(--leading-normal)',
        }}
      >
        Please contact your sales representative for assistance if you encounter difficulties completing this form.
      </p>
    </footer>
  )
}
